import {
  UpdateWhiteListIPsRequest,
  WhiteListIPSResponse,
} from "@shared/types/common";
import { sleep } from "@shared/utils/tools.ts";

export default async (data?: object) => {
  const request = data as UpdateWhiteListIPsRequest;
  await sleep(350);
  return {
    ips: request.ips,
    inProgress: false,
  } satisfies WhiteListIPSResponse;
};
